import ApiService from "../../../services/api";
import { Container, Nav } from "react-bootstrap";
import "../css/cookie_policy.css";
import parse from "html-react-parser";
import { AuthContext } from "../../../services/auth";
import { useContext, useEffect, useState } from "react";

const CookiePolicy = () => {
  const { isEnglish } = useContext(AuthContext);
  const [legalNotes, setLegalNotes] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchLegalNotes = async () => {
    const LegalNotes = await ApiService.getCookiePolicy();
    setLegalNotes(LegalNotes);
    setLoading(false);
  };

  useEffect(() => {
    fetchLegalNotes();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="padding_custom text-center">
      <h2 className="text-center section-title mt-5 text-uppercase">
      Cookie Policy
      </h2>
      <div className="border-custom mt-3"></div>
      <Container fluid="lg" className="mb-5 text_data text-start">
        {legalNotes.map((note) => {
          return (
            <div key={note.id} className="py-3 container-cookie">
              {(note.subTitle || note.subTitle_eng) &&(<h5 className="text-start text_data pb-2">
                      {isEnglish
                        ? note.subTitle_eng
                        : note.subTitle}
                    </h5>)}
              <h6 className="text-start text_container_desciption text_data ">
                {isEnglish
                  ? parse(note.description_eng)
                  : parse(note.description)}
                <Nav.Link href={note.link} target="_blank"rel="noreferrer" className="">{note.link}</Nav.Link>
              </h6>
            </div>
          );
        })}
      </Container>
    </Container>
  );
};
export default CookiePolicy;
